export default "__VITE_ASSET__B5DP9d12__"